import { useMedia } from 'tamagui';

export const useNumColumns = () => {
  const media = useMedia();
  let numColumns = 1;

  if (media.xxxl) {
    numColumns = 4;
  } else if (media['xl']) {
    numColumns = 3;
  } else if (media.md) {
    numColumns = 2;
  }

  return numColumns;
};
